export default __webpack_public_path__ + "static/img_desktop_4-cc43e5e3dd1a6279eaa09ac98415a237.jpg";